import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export function getBannersActive() {
  return axios.get(`${BASE_URL}/getBannersActive`).then(({ data }) => data);
}
